import { useEffect } from 'react';

/**
 * Hook that triggers a callback when a click occurs outside the provided ref(s).
 *
 * @param {React.RefObject|React.RefObject[]} refs - Single ref or an array of refs to keep open.
 * @param {Function} handler - Callback executed when an outside click is detected.
 * @param {boolean} enabled - Optional flag to enable/disable the listener.
 */
const useClickOutside = (refs, handler, enabled = true) => {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const refList = Array.isArray(refs) ? refs : [refs];

    const listener = (event) => {
      if (
        refList.some((ref) => {
          const current = ref?.current;
          return current ? current.contains(event.target) : false;
        })
      ) {
        return;
      }

      handler?.(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [refs, handler, enabled]);
};

export default useClickOutside;

